import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { AuthenticationDataService } from '@warema/shared/authentication/data-access';
import { AuthenticationEnvironment, ENVIRONMENT } from '@warema/shared/models';
import { PopupService } from '@warema/warema-ui-angular';
import { EMPTY, Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable({
    providedIn: 'root',
})
export class UnauthenticatedInterceptor implements HttpInterceptor {
    private readonly _popupService = inject(PopupService);
    private readonly _translate = inject(TranslateService);
    private readonly _dataService = inject(AuthenticationDataService);
    private readonly _environment = inject<AuthenticationEnvironment>(ENVIRONMENT);

    public intercept(request: HttpRequest<never>, next: HttpHandler): Observable<HttpEvent<unknown>> {
        if (this._environment.authenticatedUrls.some(url => request.url.startsWith(url))) {
            return next.handle(request).pipe(
                catchError(error => {
                    if (error?.status === 401) {
                        void this._popupService
                            .openConfirmDialog(
                                this._translate.instant('SESSION_EXPIRED_POPUP'),
                                '',
                                this._translate.instant('REFRESH_BROWSER'),
                                {
                                    headline: this._translate.instant('SESSION_EXPIRED') as string,
                                    renderCloseButton: false,
                                    closeOnBackdropClick: false,
                                    force: true,
                                },
                                true,
                            )
                            .then(() => this._dataService.logout())
                            .then(() => window.location.reload());
                    }
                    return EMPTY;
                }),
            );
        } else {
            return next.handle(request);
        }
    }
}
